import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConnectOnboardingResponse, MyReferralResponse } from '../models/referral.models';

@Injectable({ providedIn: 'root' })
export class ReferralApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  /** The current user's referral code, share link, hold period and roll-up stats. */
  getMyReferral(): Observable<MyReferralResponse> {
    return this.http.get<MyReferralResponse>(`${this.baseUrl}/referral/me`);
  }

  /** Start Stripe Connect onboarding to receive payouts; returns a hosted URL to redirect to. */
  createConnectOnboarding(): Observable<ConnectOnboardingResponse> {
    return this.http.post<ConnectOnboardingResponse>(`${this.baseUrl}/referral/connect/onboarding`, {});
  }
}
